import { useStore } from "effector-react"
import { createEvent, createStore } from "effector"

type TCourseSelect = {
    name: string
    courseData?: any // Полные данные о курсе
    pricingOption?: any // Выбранная опция цены
}

// Новый тип для хранения выбранной опции цены
export type TPricingSelect = {
    format: 'online' | 'offline'
    type: 'individual' | 'closed_group' | 'group'
    price: number
}

export type TTraing =
    | 'online_1'
    | 'online_2'
    | 'online_3'
    | 'offline_1'
    | 'offline_2'
    | 'offline_3'

export type TTraingSelect = {
    id: TTraing
}

const setCourseSelect = createEvent<TCourseSelect | null>()
const setTrainingSelect = createEvent<TTraingSelect | null>()
const setPricingSelect = createEvent<TPricingSelect | null>()

const useCourseSelect = () => useStore($courseSelect)
const useTrainingSelect = () => useStore($trainingSelect)
const usePricingSelect = () => useStore($pricingSelect)

export const $courseSelect = createStore<TCourseSelect | null>(null)
    .on(setCourseSelect, (_, course) => course)

export const $trainingSelect = createStore<TTraingSelect | null>(null)
    .on(setTrainingSelect, (_, t) => t)

export const $pricingSelect = createStore<TPricingSelect | null>(null)
    .on(setPricingSelect, (_, pricing) => pricing)

export const selectors = {
    useCourseSelect,
    useTrainingSelect,
    usePricingSelect
}

export const events = {
    setCourseSelect,
    setTrainingSelect,
    setPricingSelect,
}